import { createHalfHourAppointmentSlots } from './appointmentAvailability';

interface IAvailable {
  start_date: string;
  end_date: string;
  status: string;
}

export function createArayHoursFormated(
  hoursAvailableDontFormated: IAvailable[],
  daySelected: string,
) {
  const selectedDay = daySelected === '' ? new Date() : new Date(daySelected);

  return createHalfHourAppointmentSlots(
    hoursAvailableDontFormated,
    selectedDay,
  );
}
